"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformStringToFirstLetterUpperCaseString = transformStringToFirstLetterUpperCaseString;
function transformStringToFirstLetterUpperCaseString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
//# sourceMappingURL=transformStringToFirstLetterUpperCaseString.js.map